module.exports = __webpack_public_path__ + "static/img/85.7ba9fe9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/85.png
// module id = 9wKR
// module chunks = 1